import { useEffect, useState } from "react";
import { City, CarHireSearchParams, Itinerary } from "../../types";
import { generateCarHireSearches, parseDateString } from "../../functions/ItineraryUtils";
import { Button } from "react-bootstrap";
import LoadingMessage from "../LoadingMessage";
import api from "../../api";
import { apiRoutes } from "../../routes/routes";
import { normalizeString } from "../../functions/Utils";



interface Props {
    itinerary: Itinerary,
    cities: Record<string, City> | {},
}



const CarRentalSearchPanel: React.FC<Props> = ({ itinerary, cities }) => {

    const [carhireSearches, setCarHireSearches] = useState<CarHireSearchParams[] | []>([]);
    const [selectedSearch, setSelectedSearch] = useState<CarHireSearchParams | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [offers, setOffers] = useState([]);


  
  const getKayakUrl = (search: CarHireSearchParams) => {
    const kayakUrl = `https://www.kayak.fr/cars/${normalizeString(search.pickup_city.cityname)}, ${search.pickup_city.country_code}${
      search.pickup_city.id !== search.dropoff_city.id ? `/${normalizeString(search.dropoff_city.cityname)}, ${search.dropoff_city.country_code}` : ''
    }/${search.pickup_date}/${search.dropoff_date};map`;

    return kayakUrl;
  }


  const launchSearch = async (search: CarHireSearchParams) => {

    setLoading(true);
    setSelectedSearch(search);

    try {
      const searchParams = {
        market: "FR",
        locale: "fr-FR",
        currency: "EUR",
        pickUpLocation: {
          coordinates: {
            latitude: search.pickup_city.coordinates[0],
            longitude: search.pickup_city.coordinates[1],
          },
        },
        dropOffLocation: {
          coordinates: {
            latitude: search.dropoff_city.coordinates[0],
            longitude: search.dropoff_city.coordinates[1],
          },
        },

        pickUpDate: parseDateString(`${search.pickup_date}T10:00:00`),
        dropOffDate: parseDateString(`${search.dropoff_date}T17:00:00`),
      }
      
      const res = await api.get(apiRoutes.search_carrental, {params: searchParams});



    } catch {

    } finally {
      setLoading(false);
    }
  }


    useEffect(() => {
        if(itinerary?.data?.rental_car && itinerary?.data?.departure_date){
            const searches = generateCarHireSearches(itinerary.data.rental_car, itinerary.data.departure_date, cities);
            setCarHireSearches(searches);
        }

    }, []);

    return (
      <div>
          <div className="d-flex h-100">
              {/* Menu latéral */}
              <div className="" style={{ width: '250px' }}>
                <ul className="list-group">
                  {carhireSearches && carhireSearches.map((search) => (
                    <li
                      key={search.id}
                      className={`list-group-item list-group-item-action ${
                        selectedSearch?.id === search.id ? 'active' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => launchSearch(search)}
                    >
                      <div className="fw-bold">{search.pickup_city.cityname} <small className="fw-light">{search.pickup_date}</small></div>
                      <div className="fw-bold">{search.dropoff_city.cityname} <small className="fw-light">{search.dropoff_date}</small></div>

                    </li>
                  ))}
                </ul>
              </div>

              {/* Zone principale */}
              <div className="flex-grow-1 p-4 pt-0 overflow-auto">
                {loading && <LoadingMessage />}
                
                {!loading && selectedSearch ? (
                  <div className="border rounded p-3 bg-white shadow-sm">
                    <h5>
                      Location de voiture entre {selectedSearch.pickup_city.cityname} et {selectedSearch.dropoff_city.cityname}
                    </h5>
                    <p>Date d'arrivée : {selectedSearch.pickup_date}</p>
                    <p>Date de départ : {selectedSearch.dropoff_date}</p>
                    {/* Ici, on imaginerait le composant qui déclenche une vraie recherche */}
                    <Button variant="primary" href={getKayakUrl(selectedSearch)} target="_blank" rel="noopener noreferrer">
                    Rechercher sur Kayak
                    </Button>
                  </div>
                ) : (
                  <p className="text-muted">Cliquez sur une recherche à gauche pour voir les résultats.</p>
                )}
              </div>
            </div>
      </div>
    )

};

export default CarRentalSearchPanel;